import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=405f2c3c&scoped=true&"
import script from "./ReminderModal.vue?vue&type=script&lang=ts&"
export * from "./ReminderModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=405f2c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f2c3c",
  null
  
)

export default component.exports